import styled from "@emotion/styled";
import { NavLink } from "react-router-dom";

const NavContainer = styled.nav`
  @media (max-width: 899px) {
    margin: 10px 0;
  }
  text-align: center;
`;

const NavList = styled.ul`
  padding: 0;
`;

const NavListItem = styled.li`
  display: inline-block;
  padding: 10pt 9pt;
  @media (max-width: 899px) {
    display: block;
    padding: 15pt;
  }
`;

const NavLinkItem = styled(NavLink)`
  text-decoration: none;
  color: #333;
  font-size: 20pt;
  @media (max-width: 899px) {
    font-size: 14pt;
  }
  padding: 2pt 0;
  &:hover {
    color: #000;
    text-decoration: underline;
    text-underline-offset: 8px;
  }
  &.active {
    color: #000;
    font-weight: bold;
  }
`;

interface Props {
  onMenuSelection: () => void;
}

const Navigation = ({ onMenuSelection }: Props) => {
  return (
    <NavContainer>
      <NavList>
        <NavListItem>
          <NavLinkItem onClick={onMenuSelection} to={`/`}>home</NavLinkItem>
        </NavListItem>
        <NavListItem onClick={onMenuSelection}>
          <NavLinkItem to={`/originals`}>originals</NavLinkItem>
        </NavListItem>
        <NavListItem onClick={onMenuSelection}>
          <NavLinkItem to={`/prints`}>prints</NavLinkItem>
        </NavListItem>
        <NavListItem onClick={onMenuSelection}>
          <NavLinkItem to={`/cards`}>cards</NavLinkItem>
        </NavListItem>
        <NavListItem>
          <NavLinkItem onClick={onMenuSelection} to={`/about`}>about</NavLinkItem>
        </NavListItem>
        <NavListItem>
          <NavLinkItem onClick={onMenuSelection} to={`/contact`}>contact</NavLinkItem>
        </NavListItem>
      </NavList>
    </NavContainer>
  );
};

export default Navigation;
